import React from 'react';

import { IServerOrder } from '@rbi-ctg/menu';
import DeliveryConfirmation from 'pages/order-confirmation/delivery/delivery-confirmation';

import { StyledModal } from './details-modal.styled';

const IsEnRouteModal: React.FC<{
  serverOrder: IServerOrder;
  onModalDismiss: (orderId: string) => void;
}> = ({ serverOrder, onModalDismiss }) => {
  return (
    <StyledModal
      onDismiss={() => onModalDismiss('')}
      mParticleEventData={{
        modalAppearanceEventMessage: 'Order Details',
      }}
    >
      <DeliveryConfirmation serverOrder={serverOrder} isInsideModal />
    </StyledModal>
  );
};

export default IsEnRouteModal;
